module.exports = __webpack_public_path__ + "img/red-2-squiggly-open.b06e25e6.svg";